<template >
    <div style="background-color: white; padding: 1%;">
        <q-btn icon="close" flat round dense v-close-popup />

        <div>
            <div style="width: 85%; margin: auto;">
                <h5><q-icon name="join_full" /> Associer les fichier et les points</h5>
                <q-list padding>
                    <q-item v-for="point in points" :key="point.id">
                        <q-item-section>
                            <q-item-label class="my-label" overline>
                                <h6>{{ point.name }}</h6>
                            </q-item-label>
                        </q-item-section>

                        <q-item-section v-if="resourcesFromPoints">
                            <q-item-label overline>
                                <FileSelect :options="resources" option-label="title" option-value="resource_id" outlined
                                    v-model="resourcesFromPoints[point.id]" label="Choisir les fichiers" emit-value
                                    map-options multiple />
                            </q-item-label>
                        </q-item-section>
                    </q-item>
                </q-list>
                <br>
                <q-btn style='margin-right: 1%' color="secondary" @click="saveResources()">Enregistrer</q-btn>
                <q-btn color="pink-10" label="Retour" @click="$emit('closePointResourceAssociation')"></q-btn>
            </div>
        </div>
        <q-banner v-if="success" class="app-banner app-banner--success" dense rounded>
            Ressource enregistrée
        </q-banner>
    </div>
</template>
<script>
import { useStore } from "vuex";
import { ref, computed, onMounted } from "vue";
import { useRouter } from "vue-router";
import axios from "axios";
import FileSelect from "../components/FileSelect.vue";
export default {
    components: {
        FileSelect
    },
    setup() {
        const store = useStore();
        const router = useRouter();

        const name = computed(() => store.state.exhibitName);
        let mainResourceId = ref();
        let points = ref([]);
        let selectedPoint = ref();
        let resources = ref([]);
        let selectedResources = ref([]);
        let resourcesFromPoints = ref();
        let isUpdate = ref(false);
        let success = ref(false);
        const exhibitId = computed(() => store.state.exhibitId);
        const start = async () => {
            setTimeout(async () => {
                await getMainResource();
                await getPoints();
                await getResources();
                await getResourcesFromPoints();
            }, 1000)

        }
        const getPoints = async () => {
            try {
                console.log("getPoints")
                let url = `${process.env.VUE_APP_BASEURL}/points/${mainResourceId.value}`;
                let response = await axios.get(url);
                points.value = response.data;
            } catch (error) {
                console.log(error);
            }
        }

        const getResources = async () => {
            try {
                let url = `${process.env.VUE_APP_BASEURL}/resources/${store.state.exhibitId}`;
                let response = await axios.get(url);
                resources.value = response.data;
                resources.value = resources.value.sort((a, b) => {
                    const titleA = a.title ? a.title.toUpperCase() : "";
                    const titleB = b.title ? b.title.toUpperCase() : "";
                    if (titleA < titleB) return -1;
                    if (titleA > titleB) return 1;
                    return 0;
                });
            } catch (error) {
                console.log(error)
            }
        }

        const getMainResource = async () => {
            try {
                let url = `${process.env.VUE_APP_BASEURL}/mainresource/${exhibitId.value}`;
                let response = await axios.get(url);
                if (response.data[0]) {
                    mainResourceId.value = response.data[0].main_resource_id;
                }
            } catch (error) {
                console.log(error);
            }
        };

        const modif = (pointId) => {
            isUpdate.value = true;
            console.log(pointId)
            //delete selectedResources.value[pointId];
            //delete resourcesFromPoints.value[pointId];
        }


        const navigate = () => {
            router.go(-1);
        };

        const saveResources = async () => {
            try {
                let url = `${process.env.VUE_APP_BASEURL}/pointresourceassociation`;
                let postBody = resourcesFromPoints.value;
                await axios.post(url, postBody);
                success.value = true;
                setTimeout(() => {
                    success.value = false;
                }, 1500);
            } catch (error) {
                console.log(error);
            }
        }

        const getResourcesFromPoints = async () => {
            try {
                let url = `${process.env.VUE_APP_BASEURL}/pointsFromMainResource/${mainResourceId.value}`;
                let response = await axios.get(url);
                var outputJSON = {};
                response.data.forEach(function (item) {
                    if (
                        !Object.prototype.hasOwnProperty.call(outputJSON, item.point_id)
                    ) {
                        outputJSON[item.point_id] = [];
                    }
                    outputJSON[item.point_id].push(item.resource_id);
                });
                resourcesFromPoints.value = outputJSON;
            } catch (error) {
                console.log(error);
            }
        };

        const navigateToIntermediate = () => {
            router.push("/intermediate");
        };

        onMounted(start);

        return {
            name,
            points,
            selectedPoint,
            resources,
            resourcesFromPoints,
            success,
            navigate,
            selectedResources,
            getResources,
            saveResources,
            navigateToIntermediate,
            modif
        }
    }

}
</script>
<style scoped>
.menu {
    margin: 1%;
    display: flex;
    justify-content: space-between;
}

.nav-section {
    margin-bottom: 15px;
}

.back-btn {
    margin-left: 7%;
}

.my-label {
    font-family: 'Roboto', sans-serif;
}

.banner {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 99999;

    /* Design */
    padding: 15px 30px;
    border-radius: 5px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);

    /* Typographie */
    font-size: 16px;
    font-family: 'Helvetica', sans-serif;
    /* Remplacez par la police de votre choix */

    /* Transition */
    transition: all 0.3s ease-in-out;
}
</style>